import { Upstream } from '@/infrastructure/network/Upstream/schema'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'
import { IQueryProps } from '@/entities/Upstream/Query'

export class GetNews implements APIRequest<Upstream.News.GetNewsResponse> {
  response: Upstream.News.GetNewsResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(id: string) {
    this.path = `/news/${id}`
  }
}

export class FetchNews implements APIRequest<Upstream.News.FetchNewsResponse> {
  response: Upstream.News.FetchNewsResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: IQueryProps
  constructor(query?: IQueryProps) {
    this.params = query
    this.path = `/news`
  }
}
